import React from 'react'
import { useLocalState } from '../../../../shared/UseLocalState'
import { ServiceDto } from '../../../../api'
import { actualShowState } from '../../../../state/ActualShow.state'
import { registrationState, ServiceDtoWithAmount } from '../Registration.state'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputNumber } from 'primereact/inputnumber'
import { Checkbox } from 'primereact/checkbox'

interface ServiceSelectionPanelProps {
  types?: string[]
  title?: string
  disabled?: boolean
}

export const ServiceSelectionPanel = ({ types, title, disabled }: ServiceSelectionPanelProps) => {
  /* STATE */
  const services = useLocalState<ServiceDto[]>(actualShowState.actualShowServices$, actualShowState.actualShowServices$.value)
  const selectedServices = useLocalState<ServiceDtoWithAmount[]>(
    registrationState.selectedServices$,
    registrationState.selectedServices$.value
  )

  /* DERIVED STATE */
  const filteredServices = React.useMemo(() => {
    if (!types || types.length === 0) {
      return services?.filter((s) => !s?.type)
    }
    return services?.filter((s) => s?.type && types.includes(s.type))
  }, [services, types])

  /* METHOD TO HANDLE QUANTITY CHANGE */
  const handleQuantityChange = (_value: number, serviceId: number) => {
    const value: number = _value ?? 0
    const service = services.find((s) => s.id === serviceId)
    if (service) {
      if ((value ?? 0) > 0) {
        registrationState.selectedServices$.next([...selectedServices?.filter((s) => s?.id !== serviceId), { ...service, amount: value }])
      } else {
        registrationState.selectedServices$.next([...selectedServices?.filter((s) => s?.id !== serviceId)])
      }
    }
  }

  if (!filteredServices?.length) return null

  return (
    <div style={{ marginTop: '1rem' }}>
      {title && <h3>{title}</h3>}
      <DataTable
        showSelectAll={false}
        showHeaders={true}
        value={filteredServices}
        emptyMessage='Keine Services verfügbar'
      >
        <Column
          headerStyle={{ width: '3rem' }}
          body={(_service: ServiceDto) => {
            const service = selectedServices?.find((s) => s?.id === _service?.id)
            return (_service?.maxCount ?? 0) > 1 ? (
              ''
            ) : (
              <Checkbox
                checked={(service?.amount ?? 0) > 0}
                disabled={disabled}
                onChange={(e) => {
                  const checked = e?.checked ?? false
                  if (_service?.id) {
                    handleQuantityChange(checked ? 1 : 0, _service?.id)
                  }
                }}
              />
            )
          }}
        />
        <Column
          header='Menge'
          headerStyle={{ width: '3rem' }}
          body={(_service: ServiceDto) => {
            const service = selectedServices?.find((s) => s?.id === _service?.id)
            return (_service?.maxCount ?? 0) > 1 ? (
              <InputNumber
                inputStyle={{ maxWidth: '3rem', textAlign: 'end' }}
                value={service?.amount ?? 0}
                onBlur={(e) => handleQuantityChange(parseInt(e?.target?.value ?? '0'), _service.id ?? 0)}
                disabled={disabled}
                min={0}
                max={99}
                maxFractionDigits={0}
              />
            ) : (
              <div style={{ textAlign: 'center' }}>1</div>
            )
          }}
        />
        <Column
          header='Bezeichnung'
          body={(service: ServiceDto) => (
            <div>
              <p>{service?.name}</p>
            </div>
          )}
        />
        <Column
          header='Preis'
          body={(service: ServiceDto) => (
            <div>
              {service?.price?.toFixed(2).replace('.', ',') + '\u00a0€'}
            </div>
          )}
        />
      </DataTable>
    </div>
  )
}
